<template>
  <div>
    <transition
      enter-class="opacity-0"
      enter-active-class="ease-out duration-300 transition"
      enter-to-class="opacity-100"
      leave-class="opacity-100"
      leave-active-class="transition ease-in duration-300"
      leave-to-class="opacity-0"
      @before-enter="removeBodyScroll"
      @after-leave="addBodyScroll"
    >
      <div
        v-if="isOpen"
        class="fixed inset-0 transition-opacity max-w-screen max-h-screen overflow-hidden w-full h-full z-998"
      >
        <div class="absolute inset-0 bg-neutral-900 opacity-75" />
      </div>
    </transition>

    <transition
      enter-active-class="transition ease-out duration-100"
      enter-class="opacity-0 translate-y-4"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition ease-in duration-75"
      leave-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 translate-y-4"
    >
      <div
        v-if="isOpen"
        class="fixed inset-0 z-999 overflow-y-auto lg:overflow-y-scroll"
        @click="closeBackdrop"
        @keydown.esc="closeBackdrop"
      >
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <div
            class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transition-all sm:my-20 sm:align-middle sm:max-w-lg w-full"
            :class="{
              'sm:max-w-lg': size === 'sm',
              'sm:max-w-xl': size === 'md',
              'sm:max-w-2xl': size === 'lg',
              'sm:max-w-3xl': size === 'xl',
              'sm:max-w-4xl': size === '2xl',
            }"
            role="dialog"
            aria-modal="true"
            :aria-labelledby="headerId"
            @click.stop=""
          >
            <header class="px-4 pt-6 sm:px-6 rounded-t-lg">
              <div class="absolute top-5 right-5">
                <button
                  :aria-label="$t('app.close-panel')"
                  class="text-neutral-900 hover:text-black transition"
                  type="button"
                  @click="close"
                >
                  <svg
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </header>
            <div>
              <slot ref="default" />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { uuid } from '@/helpers/uuid';
import CloseOnEscape from '@/mixins/CloseOnEscape';

export default {
  name: 'VetsterHeadlessModal',

  mixins: [CloseOnEscape],

  props: {
    id: {
      type: String,
      default: undefined,
    },
    isBackdropClose: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'sm',
    },
  },

  data() {
    return {
      isOpen: false,
      confirmed: false,
    };
  },

  computed: {
    headerId() {
      return `modal-header-${this.id || uuid()}`;
    },
  },

  methods: {
    removeBodyScroll() {
      document.body.style.overflow = 'hidden';
    },
    addBodyScroll() {
      document.body.style.overflow = '';
    },
    closeBackdrop() {
      if (this.isBackdropClose) {
        this.close();
      }
    },
    open() {
      this.isOpen = true;
      this.confirmed = false;
      if (this.isBackdropClose) {
        this.closeOnEscape(this.close);
      }
    },
    close() {
      this.$emit('close');
      this.isOpen = false;
      this.destroyCloseOnEscape();
    },
  },
};
</script>
